import React from "react";
import styles from "./DescriptiveContainer.local.scss";

export function DescriptiveContainer({
  cssClass,
  spanCss,
  label,
  indicator,
  children
}) {
  return (
    <div className={cssClass || ""}>
      <div className={styles.container}>
        {children}
        {label &&
          indicator && (
            <span className={spanCss || ""}>
              <p>{indicator}</p> {label}
            </span>
          )}
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/Common/DescriptiveContainer/DescriptiveContainer.js